import { render, staticRenderFns } from "./case_rest_api.vue?vue&type=template&id=e6c5f46e&"
import script from "./case_rest_api.vue?vue&type=script&lang=js&"
export * from "./case_rest_api.vue?vue&type=script&lang=js&"
import style0 from "./case_rest_api.vue?vue&type=style&index=0&id=e6c5f46e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
